import {useEffect} from 'react'
import {config} from '../../config'

export function RedirectLogin() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const pammManagerId = params.get('pammManager')
    const pammOfferId = params.get('pammOffer')

    if (pammManagerId && pammOfferId) {
      // Cookie is set by PammCookieSetter (single source). Redirect to sign-up.
      window.location.href = `${config.newFrontendUrl}/sign-up?pammManager=${pammManagerId}&pammOffer=${pammOfferId}`
    } else {
      window.location.href = `${config.newFrontendUrl}/log-in`
    }
  }, [])
  return null
}

export function RedirectSignUp() {
  useEffect(() => {
    const search = window.location.search
    window.location.href = `${config.newFrontendUrl}/sign-up${search}`
  }, [])
  return null
}

export function RedirectSignUpPartner() {
  useEffect(() => {
    const search = window.location.search
    window.location.href = `${config.newFrontendUrl}/sign-up/partner${search}`
  }, [])
  return null
}

export function RedirectForgotPassword() {
  useEffect(() => {
    window.location.href = `${config.newFrontendUrl}/password-recover`
  }, [])
  return null
}
